const FETCH_TODOS = "FETCH_TODOS";
const CREATE_TODO = "CREATE_TODO";
const UPDATE_TODOS = "UPDATE_TODOS";
const STORE_TAGS = "STORE_TAGS";

export {
    FETCH_TODOS, CREATE_TODO, UPDATE_TODOS, STORE_TAGS,
};